// extracted by mini-css-extract-plugin
module.exports = {"style":{"fontFamily":"'__inter_934cb1', '__inter_Fallback_934cb1'"},"className":"__className_934cb1","variable":"__variable_934cb1"};